import { Alert, GridCol, MantineTheme, Table, Text } from "@mantine/core";
import { DntInfo, FormFileFieldLabels } from "types/module/Firmware";

const VersionComparison = ({ fieldLabels, dntInfo } : { fieldLabels: FormFileFieldLabels; dntInfo: DntInfo }) => {
  return (
    <GridCol span={12}>
      <Alert color="yellow" title="Note">
        <Text size="xs">{dntInfo.messageDetails}</Text>
        <Table
          style={(theme: MantineTheme) => ({
            fontSize: theme.fontSizes.xs,
            lineHeight: "1",
          })}
        >
          <Table.Thead>
            <Table.Tr>
              <Table.Th></Table.Th>
              <Table.Th>Existing file</Table.Th>
              <Table.Th>Your uploaded file</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            <Table.Tr>
              <Table.Th>{fieldLabels.manufacturer}</Table.Th>
              <Table.Td>
                {dntInfo.messageComparison.manufacturerName || "-"}
              </Table.Td>
              <Table.Td>
                {dntInfo.messageComparison.manufacturerName || "-"}
              </Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Th>{fieldLabels.danteProductFamily}</Table.Th>
              <Table.Td>
                {dntInfo.messageComparison.danteProduct || "-"}
              </Table.Td>
              <Table.Td>{dntInfo.product}</Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Th>{fieldLabels.danteFirmware}</Table.Th>
              <Table.Td
                c={`${
                  dntInfo.messageComparison.danteFirmwareVersion !==
                    dntInfo.firmwareVersion && "red"
                }`}
              >
                {dntInfo.messageComparison.danteFirmwareVersion || "-"}
              </Table.Td>
              <Table.Td
                c={`${
                  dntInfo.messageComparison.danteFirmwareVersion !==
                    dntInfo.firmwareVersion && "red"
                }`}
              >
                {dntInfo.firmwareVersion || "-"}
              </Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Th>{fieldLabels.modelName}</Table.Th>
              <Table.Td
                c={`${
                  dntInfo.messageComparison.oemModelName !==
                    dntInfo.modelName && "red"
                }`}
              >
                {dntInfo.messageComparison.oemModelName || "-"}
              </Table.Td>
              <Table.Td
                c={`${
                  dntInfo.messageComparison.oemModelName !==
                    dntInfo.modelName && "red"
                }`}
              >
                {dntInfo.modelName || "-"}
              </Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Th>{fieldLabels.modelId}</Table.Th>
              <Table.Td
                c={`${
                  dntInfo.messageComparison.modelId !== dntInfo.modelId && "red"
                }`}
              >
                {dntInfo.messageComparison.modelId || "-"}
              </Table.Td>
              <Table.Td
                c={`${
                  dntInfo.messageComparison.modelId !== dntInfo.modelId && "red"
                }`}
              >
                {dntInfo.modelId || "-"}
              </Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Th>{fieldLabels.modelVersion}</Table.Th>
              <Table.Td
                c={`${
                  dntInfo.messageComparison.oemModelVersion !==
                    dntInfo.productVersion && "red"
                }`}
              >
                {dntInfo.messageComparison.oemModelVersion || "-"}
              </Table.Td>
              <Table.Td
                c={`${
                  dntInfo.messageComparison.oemModelVersion !==
                    dntInfo.productVersion && "red"
                }`}
              >
                {dntInfo.productVersion || "-"}
              </Table.Td>
            </Table.Tr>
          </Table.Tbody>
        </Table>
      </Alert>
    </GridCol>
  );
};

export default VersionComparison;
